import React from 'react';

const NetworkIntelligenceFilterBar = ({ filters, onRefresh }) => {
  const {
    riskType,
    setRiskType,
    severity,
    setSeverity,
    scopeType,
    setScopeType,
    area,
    setArea,
    confidenceThreshold,
    setConfidenceThreshold,
  } = filters;

  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-3">
      <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-6">
        <select value={riskType} onChange={(e) => setRiskType(e.target.value)} className="rounded-md border border-slate-700 bg-slate-950 px-3 py-2 text-sm">
          <option value="ALL">Semua Tipe Risiko</option>
          <option value="PPPOE_SYSTEM_RISK">PPPoE System</option>
          <option value="AREA_DEGRADATION_RISK">Degradasi Area</option>
          <option value="ACCESS_CAPACITY_RISK">Kapasitas Akses</option>
          <option value="FLAPPING_CLUSTER_RISK">Flapping Cluster</option>
          <option value="SLA_CONCENTRATION_RISK">Konsentrasi SLA</option>
          <option value="ACTIVATION_PRESSURE_RISK">Tekanan Aktivasi</option>
        </select>

        <select value={severity} onChange={(e) => setSeverity(e.target.value)} className="rounded-md border border-slate-700 bg-slate-950 px-3 py-2 text-sm">
          <option value="ALL">Semua Severity</option>
          <option value="CRITICAL">Critical</option>
          <option value="HIGH">High</option>
          <option value="MEDIUM">Medium</option>
          <option value="LOW">Low</option>
        </select>

        <select value={scopeType} onChange={(e) => setScopeType(e.target.value)} className="rounded-md border border-slate-700 bg-slate-950 px-3 py-2 text-sm">
          <option value="ALL">Semua Scope</option>
          <option value="SYSTEM">System</option>
          <option value="AREA">Area</option>
          <option value="OLT">OLT</option>
          <option value="PON">PON</option>
          <option value="ODP">ODP</option>
        </select>

        <input
          type="text"
          value={area}
          onChange={(e) => setArea(e.target.value)}
          placeholder="Filter area"
          className="rounded-md border border-slate-700 bg-slate-950 px-3 py-2 text-sm"
        />

        <select
          value={String(confidenceThreshold)}
          onChange={(e) => setConfidenceThreshold(Number(e.target.value))}
          className="rounded-md border border-slate-700 bg-slate-950 px-3 py-2 text-sm"
        >
          <option value="0">Confidence >= 0%</option>
          <option value="0.4">Confidence >= 40%</option>
          <option value="0.6">Confidence >= 60%</option>
          <option value="0.8">Confidence >= 80%</option>
        </select>

        <button
          type="button"
          onClick={onRefresh}
          className="rounded-md border border-blue-500/40 bg-blue-500/20 px-3 py-2 text-sm font-medium text-blue-200 hover:bg-blue-500/30"
        >
          Refresh
        </button>
      </div>
    </div>
  );
};

export default NetworkIntelligenceFilterBar;
